var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"primary lighten-2",attrs:{"to":_vm.linkToOrder()}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v(_vm._s(_vm.$icons.orders.orders))]),_c('strong',[_vm._v(_vm._s(_vm.orderId))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }